import { useCheditor } from '@/utils'
import { Button, Form, Input, message, Radio, Select, Space, Typography, Upload } from 'antd'
import { useEffect, useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { useCreateTemplate, useGetAttachments, useGetPhishingPages } from './utils'
const { useForm } = Form
const { Option } = Select
import { parseEml, readEml, GBKUTF8, decode } from 'eml-parse-js'
import { GetEmail } from '@/api/template'
import { useDebounceFn } from 'ahooks'
import { Message } from '@/components/message'
import { t } from '@/i18n'
export const CreateEmail = props => {
  const { submit, acquire, form } = props
  const [getPhishingParams, setGetPhishingParams] = useState<GetEmail>({
    limit: 9999999,
    page: 1,
    name: '',
  })
  const [getPhishingPages, getPhishing] = useGetPhishingPages({
    GetPhishingParams: getPhishingParams,
  })
  const [getAttachments, getAttachmentsList] = useGetAttachments({
    GetAttachmentsParams: getPhishingParams,
  })
  // useEffect(() => {
  //   if (submit.accomplish) {
  //     form.submit()
  //   }
  // }, [submit.timestamp])

  const onFinish = (values: any) => {
    const { name, subject, emailType, sender, link, templateId } = values
    let value = editor?.getData()
    let arr = []
    if (emailType === 1) {
      if (!resList || resList?.length === 0) {
        return
      }
      resList?.map(item => {
        const reg2 = /href=\"([^\"]+)/gim
        const reg3 = />(.*)<\/a>/gim
        const reg4 = /(?<=>)(.|\s)*?(?=<\/?\w+[^<]*>)/gim
        const links = item.match(reg2)
        const urls = links?.[0]?.slice(links?.[0]?.indexOf('=') + 2)
        if (urls === values.link) {
          value = value.replaceAll(urls, `{{.Url}}`)
          arr.push(item.match(reg3)[0].match(reg4).join(''))
        }
      })
    }
    // if (value?.indexOf('<script') > 0 && value?.indexOf('</script>') > 0) {
    //   let arr = value.split('<script')
    //   arr.map(() => {
    //     // value.substring(value.indexOf('<script>'), value.indexOf('</script>'))
    //     if (value.indexOf('<script') > 0 && value.indexOf('</script') > 0) {
    //       value = value.replaceAll(
    //         value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
    //         '',
    //       )
    //     }
    //   })
    // }
    createTemplate({
      name,
      subject,
      content: value,
      email_type: emailType,
      sender,
      cover: '/static/default/phishEmail.png',
      link: emailType === 1 ? [arr[0]] : [],
      template_id: templateId || '',
    })
      .then(res => {
        acquire()
        form.resetFields()
      })
      .catch(err => {})
  }
  const [createTemplate] = useCreateTemplate()
  const onFinishFailed = (errorInfo: any) => {}
  let [element, setElement] = useState<HTMLDivElement | null>(null)
  let [templatetype, setTemplatetype] = useState(0)
  let [resList, setResList] = useState([])
  let [content, setContent] = useState('')
  const { editor } = useCheditor({
    height: 270,
    initData: '',
    element,
    // onKey: e => {
    //   run(e)
    // },
    onChange: e => {
      run(e)
    },
  })
  const { run } = useDebounceFn(
    value => {
      setContent(value)
      console.log(999, value)
      const regs = /<a .*?href="(.*?)">.*?<\/a>/gim
      setResList((resList = value.match(regs)))
      if (!value.match(regs) || value.match(regs)?.length === 0) {
        form.setFieldsValue({ link: undefined })
      }
      // replaceFn(value)
    },
    {
      wait: 500,
    },
  )
  const replaceFn = value => {
    if (value?.indexOf('window.location.replace') > 0) {
      value = value?.replaceAll('window.location.replace', 'let  ddd')
      editor?.setData(value)
    }
    if (value?.indexOf('window.location.href') > 0) {
      value = value?.replaceAll('window.location.href', 'let  ddd')
      editor?.setData(value)
    }
    if (value?.indexOf('<script') > 0 && value?.indexOf('</script>') > 0) {
      let arr = value.split('<script')
      arr.map(() => {
        if (value?.indexOf('<script') > 0 && value.indexOf('</script>') > 0) {
          value = value?.replaceAll(
            value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
            '',
          )
        }
      })
      editor?.setData(value)
    }
  }
  useEffect(() => {
    let value = editor?.getData()
    // replaceFn(value)
  }, [editor?.getData()])
  return (
    <FomrItem onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
      <Form.Item
        name="name"
        label="模板名称"
        rules={[
          { required: true, message: '请输入模板名称' },
          { max: 25, message: '模板名称最多25个字符' },
          {
            pattern: /^(?=.*\S).+$/,
            message: '模板名称不能全部为空格!',
          },
        ]}
      >
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item
        name="emailType"
        label="邮件模板类型"
        rules={[{ required: true, message: '请选择模板类型' }]}
      >
        <Radio.Group
          onChange={e => {
            setTemplatetype((templatetype = e.target.value))
            form.setFieldsValue({ templateId: null })
          }}
        >
          <Radio value={1}>{t('钓鱼链接')}</Radio>
          <Radio value={2}>{t('恶意附件')}</Radio>
        </Radio.Group>
      </Form.Item>
      {/* <Form.Item label="发件地址">
         <p className="email">{'sender<sender@seeattack.com>'}</p>
        </Form.Item> */}
      <Form.Item name="sender" label="发件昵称" rules={[{ max: 64 }]}>
        <Input placeholder="请输入" />
      </Form.Item>
      <div className="subject">
        <Form.Item
          name="subject"
          label="邮件主题"
          className="main_body"
          rules={[{ required: true, message: '请输入邮件主题' }]}
        >
          <Input placeholder="请输入" />
        </Form.Item>
        <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '25px' }}>
          <Upload
            name="content"
            showUploadList={false}
            maxCount={1}
            beforeUpload={file => {
              const reg = /\.(eml)$/
              if (reg.test(file.name)) {
                const reader = new FileReader()
                reader.readAsText(file)
                reader.onload = result => {
                  let targetNum = result.target.result
                  editor.setData(readEml(targetNum.toString())?.html)
                }
                return true
              }
              Message.error('仅支持上传eml格式文件')
              return false
            }}
          >
            <Button icon={<UploadOutlined />} style={{ marginLeft: '10px' }} type="primary">
              {t('导入EML')}
            </Button>
          </Upload>
          <span style={{ fontSize: '12px', marginLeft: '8px', color: '#999999' }}>
            {t('只能上传utf-8格式')}
          </span>
        </div>
      </div>
      <div>
        <span style={{ color: '#ff4d4f', width: 11 }}>*</span>
        <span>{t('邮件正文')}</span>
      </div>
      <div style={{ width: '100%', marginTop: 8 }}>
        <div ref={setElement} key={submit.timestamp} />
        {/* <p style={{ marginTop: 8, fontSize: 12, color: '#6F9FFF' }}>
           在文本框中输入邮件内容或拖拽EML文件到文本框
          </p> */}
      </div>
      {templatetype === 1 && (
        <>
          <Form.Item
            label="请选择更改为钓鱼页的链接"
            name="link"
            className="phishing"
            rules={[{ required: true }]}
          >
            {/* <Checkbox.Group
               style={{ width: '100%', paddingLeft: '24px' }}
               onChange={checkout => {
                 setCheckoutList((checkoutList = checkout))
               }}
               defaultValue={['{{.Url}}']}
             > */}
            <Radio.Group>
              <Space direction="vertical">
                {resList?.map((item, index) => {
                  const reg2 = /href=\"([^\"]+)/gim
                  const reg3 = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/gim
                  const reg4 = /(?<=>)(.|\s)*?(?=<\/?\w{0,}[^<]*>)/gim
                  const link = item.match(reg2)
                  const urls = link?.[0]?.slice(link?.[0]?.indexOf('=') + 2)
                  const url = item.match(reg3)
                  return (
                    <Radio value={urls} key={index}>
                      <Typography.Text style={{ width: 200 }} ellipsis>
                        {url[0].match(reg4)?.join('')}
                      </Typography.Text>
                    </Radio>
                  )
                })}
              </Space>
            </Radio.Group>
            {/* </Checkbox.Group> */}
          </Form.Item>
          <Form.Item
            name="templateId"
            label="请选择钓鱼页模板"
            className="template"
            // rules={[{ required: true, message: '请选择钓鱼页模板' }]}
          >
            <Select placeholder="请选择">
              {getPhishing?.items?.length > 0 &&
                getPhishing?.items?.map(item => (
                  <Option value={item.id} key={item.id}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </>
      )}
      {templatetype === 2 && (
        <Form.Item
          name="templateId"
          label="请选择附件模板"
          // rules={[{ required: true, message: '请选择附件模板' }]}
          style={{ width: '400px' }}
        >
          <Select placeholder="请选择">
            {getAttachmentsList?.items?.map(item => (
              <Option value={item.id} key={item.id}>
                {item.attachment_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}
    </FomrItem>
  )
}

const FomrItem = styled(Form)`
  padding-right: 30px;
  .subject {
    display: flex;
    width: 100%;
  }
  .email {
    width: 356px;
    height: 32px;
    line-height: 32px;
    background-color: #efefef;
    padding-left: 16px;
    color: #333333;
    margin: 0;
    border-radius: 6px;
  }
  .ant-form-item-label {
    width: 120px;
    text-align: left;
  }
  .ant-select-selector,
  .ant-input {
    width: 356px;
  }
  .ant-row {
    flex-wrap: nowrap;
  }
  .phishing {
    display: block;
    .ant-form-item-label {
      width: auto;
      text-align: left;
    }
  }
  .template {
    .ant-form-item-label {
      width: 150px;
      text-align: left;
    }
    .ant-form-item-control-input {
      width: 400px;
    }
  }
  .ant-row {
    display: block;
  }
`
